module.exports = __webpack_public_path__ + "img/product-bigData-three.3a16f95.png";